import React, { useState } from 'react'

import Dialog from 'components/Dialog'
import Link from 'components/Link'
import { useEventContext } from 'context/EventContext'

const ReviewMethodologyModal = ({
  targetComponent = 'product_overview',
  linkText = 'Learn more about our reviews.',
  className = '',
}) => {
  const [isOpen, setOpen] = useState(false)
  const { sendEvent } = useEventContext({
    name: 'engagement_facet_click',
    engagementComponent: targetComponent,
    engagementDestination: 'modal_reviews-methodology',
  })
  const handleOpen = () => {
    setOpen(true)
    sendEvent({
      engagementDetails: 'open_text-link_learn-more-about-our-reviews',
    })
  }

  const handleClose = () => {
    setOpen(false)
    sendEvent({
      engagementDetails: 'close_text-link_learn-more-about-our-reviews',
    })
  }

  return (
    <>
      <Link className={className} onClick={handleOpen}>
        {linkText}
      </Link>
      <Dialog title="Learn more about our reviews" onClose={handleClose} isOpen={isOpen} isSeoFriendly>
        <p>
          GetApp maintains a proprietary database of millions of in-depth, verified user reviews across thousands of
          products in hundreds of software categories. Our data scientists apply advanced modeling techniques to
          identify key insights about products based on those reviews. We may also share aggregated ratings and select
          excerpts from those reviews throughout our site.
        </p>
      </Dialog>
    </>
  )
}

export default ReviewMethodologyModal
